module.exports = __webpack_public_path__ + "img/arrow-up-from-bracket.18a021e0.svg";